import { FunctionComponent } from "react";
import { Link } from "react-router-dom";
import { Link as ScrollLink } from "react-scroll";
import { Link as RouterLink, useLocation } from "react-router-dom";
import "../../global.css";
import logo from "../../assets/svg/light-rectangle.svg";

import google_pay from "../../assets/svg/logo_google_pay.svg";
import apple_pay from "../../assets/svg/logo_apple_pay.svg";
import visa from "../../assets/svg/logo_visa.svg";
import maestro from "../../assets/svg/logo_maestro.svg";
import mastercard from "../../assets/svg/logo_mastercard.svg";
import { useTranslation } from "../../TranslationContext";

const Footer: FunctionComponent = () => {
  const translations = useTranslation();
  const location = useLocation();

  return (
    <div
      id="footer"
      className="relative w-full flex flex-col items-center justify-center bg-white"
    >
      <footer className="self-stretch bg-black flex flex-col py-20 md:py-16 sm:pt-10 sm:pb-24 px-24 items-center justify-center gap-12 text-left text-2xl text-white font-text-base-font-medium lg:px-12 md:px-8 mt-24">
        <div className="w-full flex flex-row flex-wrap items-center md:items-start justify-center gap-2 max-w-[1440px] xl:flex-col lg:flex-col md:flex-row">
          <div className="h-[200px] w-auto sm:w-full flex flex-col py-10 px-10 box-border items-center justify-center sm:py-0 sm:px-0">
            <img
              className="relative w-[200px] h-[113.06px] overflow-hidden shrink-0 "
              alt="DTF Rakete"
              src={logo}
            />
          </div>
          <div className="flex-1 flex flex-row items-start justify-end xl:justify-between sm:flex-col gap-10 2xl:gap-4 sm:grid-cols-1 xs:grid-cols-1 w-fit sm:px-4 md:px-6 xs:px-0">
            <div className="flex flex-col py-2 items-start justify-center xl:hidden gap-4 px-4 lg:px-4 md:px-0">
              <div className="relative leading-[150%] font-semibold">{translations.footer.info.title}</div>
              <div className="flex flex-col items-start justify-center gap-2 text-base text-slate-300">
                {location.pathname === "/" ? (
                  <ScrollLink
                    to="pricing"
                    smooth={true}
                    duration={500}
                    offset={-88}
                    className="[text-decoration:none] relative leading-[150%] text-[inherit] cursor-pointer"
                  >
                    {translations.footer.info.pricing}
                  </ScrollLink>
                ) : (
                  <RouterLink
                    to="/#pricing"
                    className="[text-decoration:none] relative leading-[150%] text-[inherit] cursor-pointer"
                  >
                    {translations.footer.info.pricing}
                  </RouterLink>
                )}
                {location.pathname === "/" ? (
                  <ScrollLink
                    to="services"
                    smooth={true}
                    duration={500}
                    offset={-88}
                    className="[text-decoration:none] relative leading-[150%] text-[inherit] cursor-pointer"
                  >
                    {translations.footer.info.samples}
                  </ScrollLink>
                ) : (
                  <RouterLink
                    to="/#services"
                    className="[text-decoration:none] relative leading-[150%] text-[inherit] cursor-pointer"
                  >
                    {translations.footer.info.samples}
                  </RouterLink>
                )}
                {location.pathname === "/" ? (
                  <ScrollLink
                    to="testimonials"
                    smooth={true}
                    duration={500}
                    offset={-88}
                    className="[text-decoration:none] relative leading-[150%] text-[inherit] cursor-pointer hidden"
                  >
                    {translations.footer.info.reviews}
                  </ScrollLink>
                ) : (
                  <RouterLink
                    to="/#testimonials"
                    className="[text-decoration:none] relative leading-[150%] text-[inherit] cursor-pointer hidden"
                  >
                    {translations.footer.info.reviews}
                  </RouterLink>
                )}
                {location.pathname === "/" ? (
                  <ScrollLink
                    to="faq"
                    smooth={true}
                    duration={500}
                    offset={-88}
                    className="[text-decoration:none] relative leading-[150%] text-[inherit] cursor-pointer"
                  >
                    {translations.footer.info.faq}
                  </ScrollLink>
                ) : (
                  <RouterLink
                    to="/#faq"
                    className="[text-decoration:none] relative leading-[150%] text-[inherit] cursor-pointer"
                  >
                    {translations.footer.info.faq}
                  </RouterLink>
                )}
                <div className="relative leading-[150%]">
                  <Link
                    to="/contact"
                    className="[text-decoration:none] relative leading-[150%] text-[inherit]"
                    onClick={() => window.scrollTo(0, 0)}
                  >
                    {translations.footer.info.contact}
                  </Link>
                </div>
              </div>
            </div>
            <div className="flex flex-col py-2 items-start justify-center gap-4 px-8 lg:px-4 md:px-0">
              <div className="relative leading-[150%] font-semibold">
                {translations.footer.orders.title}
              </div>
              <div className="flex flex-col items-start justify-center gap-[8px] text-base text-slate-300">
                <Link
                  to="/order"
                  className="[text-decoration:none] relative leading-[150%] text-[inherit]"
                  onClick={() => window.scrollTo(0, 0)}
                >
                  {translations.footer.orders.orderDTF}
                </Link>
                {location.pathname === "/" ? (
                  <ScrollLink
                    to="graphic_preparation"
                    smooth={true}
                    duration={500}
                    offset={-88}
                    className="[text-decoration:none] relative leading-[150%] text-[inherit] cursor-pointer"
                  >
                    {translations.footer.orders.prepareGraphics}
                  </ScrollLink>
                ) : (
                  <RouterLink
                    to="/#graphic_preparation"
                    className="[text-decoration:none] relative leading-[150%] text-[inherit] cursor-pointer"
                  >
                    {translations.footer.orders.prepareGraphics}
                  </RouterLink>
                )}
                <Link
                  to="/delivery-policy"
                  className="[text-decoration:none] relative leading-[150%] text-[inherit]"
                  onClick={() => window.scrollTo(0, 0)}
                >
                  {translations.footer.orders.deliveryTerms}
                </Link>
                <Link
                  to="/payment-policy"
                  className="[text-decoration:none] relative leading-[150%] text-[inherit]"
                  onClick={() => window.scrollTo(0, 0)}
                >
                  {translations.footer.orders.paymentTerms}
                </Link>
              </div>
            </div>
            <div className="flex flex-col items-start py-2 justify-center gap-2 px-8 lg:px-4 md:px-0">
            <div className="relative leading-[150%] font-semibold">
                {translations.footer.contact.title}
              </div>
              <div className="flex flex-col items-start justify-center gap-[8px] text-base text-slate-300">
                <div className="relative leading-[150%]">
                  <a href="mailto:info@nexprim.com">{translations.footer.contact.email}</a>
                </div>
              </div>
              <div className="relative leading-[150%] font-semibold pt-5">
                {translations.footer.paymentMethods.title}
              </div>
              <div className="self-stretch flex flex-col items-start justify-start w-fit">
                <div className="self-stretch flex flex-row items-start justify-start gap-2 xs:gap-1">
                  <img className="relative h-5" alt="visa" src={visa} />
                  <img
                    className="relative h-5"
                    alt="mastercard"
                    src={mastercard}
                  />
                  <img className="relative h-5" alt="maestro" src={maestro} />
                  <img
                    className="relative h-5"
                    alt="apple-pay"
                    src={apple_pay}
                  />
                  <img
                    className="relative h-5"
                    alt="google-pay"
                    src={google_pay}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="w-full flex flex-col items-start justify-start gap-6 max-w-[1440px] text-base text-slate-300">
          <div className="self-stretch relative box-border h-0.5 border-t-[2px] border-solid border-slate-700" />
          <div className="self-stretch flex flex-row items-start justify-between sm:flex-col-reverse">
            <a
              href="https://nexprim.com/"
              className="[text-decoration:none] relative leading-[150%] font-medium text-[inherit]"
            >
              {translations.footer.copyright}
            </a>
            <div className="flex flex-row items-start justify-start gap-4 text-right sm:flex-col sm:mb-6">
              <Link
                to="/contact"
                className="[text-decoration:none] relative leading-[150%] font-medium text-[inherit]"
                onClick={() => window.scrollTo(0, 0)}
              >
                Impressum
              </Link>
              <Link
                to="/privacy-policy"
                className="[text-decoration:none] relative leading-[150%] font-medium text-[inherit]"
                onClick={() => window.scrollTo(0, 0)}
              >
                {translations.footer.links.privacyPolicy}
              </Link>
              <Link
                to="/terms-of-service"
                className="[text-decoration:none] relative leading-[150%] font-medium text-[inherit]"
                onClick={() => window.scrollTo(0, 0)}
              >
                {translations.footer.links.termsOfService}
              </Link>
              <Link
                to="/cookies"
                className="[text-decoration:none] relative leading-[150%] font-medium text-[inherit]"
                onClick={() => window.scrollTo(0, 0)}
              >
                {translations.footer.links.cookies}
              </Link>
            </div>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default Footer;
